import ItemCollectionWide from './ItemCollectionWide';

export default ItemCollectionWide;
